































import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv'
import { IcoChevronDownMinor } from '@bukalapak/bazaar-visual'
import Vue, { PropType } from 'vue'
import { TncContent } from '~/constants/terms/tnc-content'

export default Vue.extend({
  name: 'TermsNavigation',
  components: {
    BlTextAv,
    IcoChevronDownMinor,
  },
  props: {
    contents: {
      type: Array as PropType<TncContent[]>,
      default: () => [],
    },
  },
  data: () => ({
    isMenuOpen: false,
    currentMenuActive: '',
  }),
  computed: {
    currentTitle(): string {
      const item = this.contents.find(content => content.slug === this.currentMenuActive)
      if (item) return item?.title || ''
      return ''
    },
    isMenuActive(): object {
      return { active: this.isMenuOpen }
    },
    isDesktop(): Boolean {
      return this.$viewport.match('desktop')
    },
  },
  destroyed() {
    document.body.style.overflowY = 'auto'
    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  mounted() {
    if (this.contents && this.contents[0]) {
      this.currentMenuActive = this.contents[0]?.slug || ''
    }
    if (process.client) window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    togglePageScrollbar() {
      if (this.isMenuOpen) {
        document.body.style.overflowY = 'hidden'
      } else {
        document.body.style.overflowY = 'auto'
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      this.togglePageScrollbar()
    },
    handleScroll() {
      if (!process.client) return
      const components = [...document.querySelectorAll('section h3[id]')]
      const viewportBottom = window.innerHeight || document.documentElement.clientHeight
      for (const component of components) {
        const rect = component.getBoundingClientRect()
        const isWithinViewport = rect.top >= 0 && rect.bottom <= viewportBottom
        if (isWithinViewport) {
          this.currentMenuActive = component.id
          break
        }
      }
    },
    scrollTo(slug) {
      if (!process.client) return
      this.isMenuOpen = false
      this.$nextTick(() => {
        const headerPadding = 20
        const headerHeight = document?.querySelector('.c-header')?.clientHeight || 0
        const navigationHeight = this.isDesktop ? 0 : 37
        const headerOffset = headerHeight + navigationHeight + headerPadding
        const componentSection = document?.querySelector(`#${slug}`)
        const componentSectionPosition = componentSection?.getBoundingClientRect().top || 0
        const offsetPosition = componentSectionPosition + window.pageYOffset - headerOffset
        window.scrollTo({ top: offsetPosition })
        this.togglePageScrollbar()
      })
    },
    getNavigationClass(item) {
      const componentClass = {
        active: false,
        indent: false,
      }
      if (this.currentMenuActive === item.slug) componentClass.active = true
      if (item.indent) componentClass.indent = true
      return componentClass
    },
  },
})
